import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";

import DeviationReportSliders from "../reports/DeviationReportSliders";
import { allowableEarly, allowableLate } from "../../config";

const SlidersWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  justify-content: center;
  align-content: center;
  gap: 1rem;
  button {
    margin-top: auto !important;
    margin-bottom: auto !important;
    min-width: 4.5rem;
    height: 100% !important;
  }
`;

const EarlyLateTimeSettings = ({
  allowableLateRedux,
  allowableEarlyRedux,
  setAllowableLateRedux,
  setAllowableEarlyRedux,
  setShouldReloadWindow,
}: {
  allowableLateRedux: number;
  allowableEarlyRedux: number;
  setAllowableLateRedux: React.Dispatch<React.SetStateAction<number>>;
  setAllowableEarlyRedux: React.Dispatch<React.SetStateAction<number>>;
  setShouldReloadWindow: React.Dispatch<React.SetStateAction<boolean>>;
}): JSX.Element => {
  const { t } = useTranslation();

  const resetToDefaultValues = (): void => {
    setAllowableLateRedux(allowableLate);
    setAllowableEarlyRedux(allowableEarly);
    setShouldReloadWindow(true);
  };

  return (
    <React.Fragment>
      <SlidersWrapper>
        <DeviationReportSliders
          inputNegativeValue={allowableLateRedux}
          setInputNegativeValue={setAllowableLateRedux}
          inputValuePositive={allowableEarlyRedux}
          setInputValuePositive={setAllowableEarlyRedux}
          setShouldReloadWindow={setShouldReloadWindow}
        />

        <Button
          size={undefined}
          onClick={resetToDefaultValues}
          disabled={allowableLateRedux === allowableLate && allowableEarlyRedux === allowableEarly}
        >
          {t("Reset")}
          <br />
          {`${allowableLate} min`}
          <br />
          {`${allowableEarly} min`}
        </Button>
      </SlidersWrapper>
    </React.Fragment>
  );
};

export default EarlyLateTimeSettings;
